import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  RowDetailState,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableEditRow,
  TableEditColumn,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { Chip } from '@material-ui/core';

import PassTransactionDialog from './PassTransactionDialog.js';
import BuyPassDialog from './BuyPassDialog.js';
import AdjustPassDialog from './AdjustPassDialog.js';
import DeskTransactionDialog from './DeskTransactionDialog.js';
import PassActivationDialog from './PassActivationDialog.js';

import TooltipsTypeProvider from './data_type_provider/TooltipsTypeProvider.js';
import DateTimeTypeProvider from './data_type_provider/DateTimeTypeProvider.js';
import PhoneTypeProvider from './data_type_provider/PhoneTypeProvider.js';
import DobTypeProvider from './data_type_provider/DobTypeProvider.js';
import GenderTypeProvider from './data_type_provider/GenderTypeProvider.js';
import RoleTypeProvider from './data_type_provider/RoleTypeProvider.js';

import moment from 'moment';
import _ from 'lodash';

import firebase from 'firebase/app';
require("firebase/firestore");

const styles = theme => ({
  detailTable: {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
  },
  detailRow: {
    display: 'table-row',
  },
  detailCell: {
    display: 'table-cell',
    padding: 8,
  },
  detailCard: {
    // height: '100%',
  },
  detailCardContent: {
    display: 'flex',
    flexFlow: 'column',
    height: '100%',
  },
  detailTitle: {
    flex: '0 1 auto',
  },
  detailContent: {
    flex: '1 1 auto',
  },
  passContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  passInfo: {
    flex: 1,
    padding: 12,
  },
  passAction: {
    height: "0%"
  }
});

const getRowId = row => row.id;

const columns = [
  { name: 'name', title: 'Name' },
  { name: 'email', title: 'Email' },
  { name: 'phone', title: 'Phone' },
  { name: 'gender', title: 'Gender' },
  { name: 'occupation', title: 'Occupation' },
  { name: 'dob', title: 'DOB' },
  { name: 'registerDate', title: 'Register' },
];

const commitChanges = async ({ added, changed, deleted }) => {
  if (changed) {
    for (var rowId in changed) {

      if (changed[rowId]['dob']) {
        changed[rowId]['dob'] = changed[rowId]['dob'].toDate();
      }

      await firebase.firestore()
        .collection("users")
        .doc(rowId)
        .update(changed[rowId]);
    }
  }
};

class CustomersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: this.props.users,
      userPasses: this.props.userPasses,
      passes: this.props.passes,

      selectedCustomer: null,
      passRecordToActivation: null,
      passTransactionDialogOpen: false,
      buyPassDialogOpen: false,
      adjustPassDialogOpen: false,
      deskTransactionDialogOpen: false,
      passActivationDialogOpen: false,

      rows: [],
      filters: [],
      skip: 0,
      loading: false,

      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  // TODO
  getRemoteRows = async (requestedSkip, take) => {
    console.log(`${requestedSkip}, ${take}`);
    this.setState({ loading: true });

    const refs = _.slice(this.state.users, requestedSkip, take);
    const snapshots = await Promise.all(refs.map(ref => ref.get()));
    const rows = snapshots.map(snapshot => {
      return {
        id: snapshot.id,
        ...snapshot.data(),
      }
    });
    console.log(rows);

    this.setState({
      loading: false,
      skip: requestedSkip,
      rows: _.union(this.state.rows, rows, (a, b) => a.id === b.id)
    })
  };

  getDetailRowTemplate = ({ row }) => {
    return (
      <div className={this.props.classes.detailTable}>
        <div className={this.props.classes.detailRow}>
          {/* Passes */}
          <div className={this.props.classes.detailCell}>
            <Card className={this.props.classes.detailCard}>
              <CardContent className={this.props.classes.detailCardContent}>
                <Typography variant="h5" component="h2" className={this.props.classes.detailTitle}>
                  Passes
                </Typography>
                <div className={this.props.classes.detailContent}>
                  {
                    this.state.passes.filter(pass => pass.active).map((pass, index) => {
                      var userPass = (this.state.userPasses[row.id] || {})[pass.id];

                      var isAvailable = true;
                      var label = "";
                      var action = "";
                      switch (pass.unit) {
                        case 'time':
                        case 'day':
                          let remaining = (userPass && userPass.remaining) || 0;
                          if (remaining > 0) {
                            label = `${remaining} ${pass.unit}${remaining > 1 ? 's' : ''}`;
                          } else {
                            isAvailable = false;
                          }

                          if (userPass && userPass.expiryDate) {
                            if (moment(userPass.expiryDate.toDate()).isAfter(moment())) {
                              label += ` ~ ${moment(userPass.expiryDate.toDate()).format('ll')}`;
                            } else {
                              isAvailable = false;
                            }
                          }
                          break;
                        case 'month':
                          if (userPass) {
                            if (pass.activation && !userPass.activationDate) {
                              label = "Inactive";
                              action = <Button color="primary" onClick={() => this.handlePassActivationDialogOpen(userPass)}>Activate</Button>;
                            } if (userPass.expiryDate && moment(userPass.expiryDate.toDate()).isAfter(moment())) {
                              label = `~ ${moment(userPass.expiryDate.toDate()).format('ll')}`;
                            } else {
                              isAvailable = false;
                            }
                          } else {
                            isAvailable = false;
                          }
                          break;
                        default:
                      }

                      return (
                        <div key={pass.id} >
                          <div className={this.props.classes.passContainer}>
                            <div className={this.props.classes.passInfo}>
                              <div>
                                <Typography variant="caption">{pass.name}</Typography>
                                {' '}
                                <Chip size='small' label={pass.branch} />
                              </div>
                              <Typography variant="body1">
                                {isAvailable ? label : "-"}
                              </Typography>
                            </div>
                            <div className={this.props.classes.passAction}>
                              {action}
                            </div>
                          </div>
                          <Divider />
                        </div>
                      );
                    })
                  }
                </div>
              </CardContent>
              <CardActions>
                <Button color="primary" onClick={() => this.handleBuyPassClick(row)}>Buy</Button>
                <Button color="primary" onClick={() => this.handlePassesHistoryClick(row)}>History</Button>
                {this.props.currentUser.isAdmin ?
                  <Button color="primary" onClick={() => this.handleAdjustPassClick(row)}>Adjust</Button>
                  : null
                }
              </CardActions>
            </Card>
          </div>
          {/* Records */}
          <div className={this.props.classes.detailCell}>
            <Card className={this.props.classes.detailCard}>
              <CardContent>
                <Typography variant="h5" component="h2">Records</Typography>
              </CardContent>
              <CardActions>
                <Button color="primary" onClick={() => this.handleDeskTransactionClick(row)}>All Records</Button>
              </CardActions>
            </Card>
          </div>
          {/* Third */}
          <div className={this.props.classes.detailCell} style={{ verticalAlign: 'bottom' }}>
            <div style={{ float: 'right' }}>
              id: {row.id + (row.isAdmin ? ", admin" : "")}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handlePassesHistoryClick = (customer) => {
    this.setState({
      selectedCustomer: customer,
      passTransactionDialogOpen: true,
    });
  }

  handlePassTransactionDialogClose = () => {
    this.setState({ passTransactionDialogOpen: false });
  }

  handleBuyPassClick = (customer) => {
    this.setState({
      selectedCustomer: customer,
      buyPassDialogOpen: true,
    });
  }

  handleBuyPassDialogClose = () => {
    this.setState({ buyPassDialogOpen: false });
  }

  handleAdjustPassClick = (customer) => {
    this.setState({
      selectedCustomer: customer,
      adjustPassDialogOpen: true,
    });
  }

  handleAdjustPassDialogClose = () => {
    this.setState({ adjustPassDialogOpen: false });
  }

  handleDeskTransactionClick = (customer) => {
    this.setState({
      selectedCustomer: customer,
      deskTransactionDialogOpen: true,
    });
  }

  handleDeskTransactionDialogClose = () => {
    this.setState({ deskTransactionDialogOpen: false });
  }

  handlePassActivationDialogClose = () => {
    this.setState({
      passRecordToActivation: null,
      passActivationDialogOpen: false
    });
  }

  handlePassActivationDialogOpen = (userPassRecord) => {
    this.setState({
      passRecordToActivation: userPassRecord,
      passActivationDialogOpen: true,
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newState = {};
    if (nextProps.users) newState.users = Array.from(nextProps.users);
    if (nextProps.userPasses) {
      newState.userPasses = nextProps.userPasses;

      // refresh detail row
      if (this.rowDetailState.state.expandedRows) {
        this.rowDetailState.setDetailRowExpanded(this.rowDetailState.state.expandedRows);
      }
    }
    if (nextProps.passes) newState.passes = nextProps.passes;

    this.setState(newState);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render = () => (
    <div>
      <Paper>
        <Grid
          rows={this.state.users}
          getRowId={getRowId}
          columns={columns}>

          <TooltipsTypeProvider for={['name', 'email']} />
          <PhoneTypeProvider for={['phone']} />
          <DateTimeTypeProvider for={['registerDate']} />
          <DobTypeProvider for={['dob']} />
          <RoleTypeProvider for={['role']} />
          <GenderTypeProvider for={['gender']} />

          {/* State */}
          <EditingState onCommitChanges={commitChanges} />
          <RowDetailState ref={(obj) => { this.rowDetailState = obj }} />

          {/* Sorting */}
          <SortingState defaultSorting={[{ columnName: 'registerDate', direction: 'desc' }]} />
          <IntegratedSorting />

          {/* Filter */}
          <FilteringState />
          <IntegratedFiltering />

          <VirtualTable
            columnExtensions={[
              { columnName: 'name', width: this.state.width - 261 - 48 - 150 - 48 - 160 - 100 - 70 - 120 - 140 - 170 },
              { columnName: 'email', width: 160 },
              { columnName: 'phone', width: 100 },
              { columnName: 'gender', width: 70 },
              { columnName: 'occupation', width: 120 },
              { columnName: 'dob', width: 140 },
              { columnName: 'registerDate', width: 170 },
            ]}
            height={this.state.height - 112} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <TableRowDetail contentComponent={this.getDetailRowTemplate} />

          {/* Edit */}
          <TableEditRow />
          {this.props.currentUser.isAdmin ? <TableEditColumn showEditCommand /> : null}

        </Grid>
      </Paper>

      <PassTransactionDialog
        open={this.state.passTransactionDialogOpen}
        onRequestClose={this.handlePassTransactionDialogClose}
        userId={this.state.selectedCustomer && this.state.selectedCustomer.id}
        passes={this.state.passes} />

      <BuyPassDialog
        open={this.state.buyPassDialogOpen}
        onRequestClose={this.handleBuyPassDialogClose}
        customer={this.state.selectedCustomer}
        passes={this.state.passes}
        userPass={this.state.selectedCustomer && this.state.userPasses[this.state.selectedCustomer.id]}
        branches={this.props.branches}
        branchId={this.props.branchId} />

      <AdjustPassDialog
        open={this.state.adjustPassDialogOpen}
        onRequestClose={this.handleAdjustPassDialogClose}
        currentUser={this.props.currentUser}
        customer={this.state.selectedCustomer}
        passes={this.state.passes}
        userPass={this.state.selectedCustomer && this.state.userPasses[this.state.selectedCustomer.id]} />

      <DeskTransactionDialog
        open={this.state.deskTransactionDialogOpen}
        onRequestClose={this.handleDeskTransactionDialogClose}
        userId={this.state.selectedCustomer && this.state.selectedCustomer.id}
        passes={this.state.passes} />

      <PassActivationDialog
        open={this.state.passActivationDialogOpen}
        onRequestClose={this.handlePassActivationDialogClose}
        passRecord={this.state.passRecordToActivation} />

    </div>
  );
}

CustomersTable.propTypes = {
  classes: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  userPasses: PropTypes.object.isRequired,
  passes: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  branchId: PropTypes.string,
};

export default withStyles(styles)(CustomersTable);
